import React, {
  ReactNode,
  createContext,
  Dispatch,
  SetStateAction,
} from "react";
import useSettings from "./hooks/useSettings";

interface SettingsContextProviderProps {
  children: ReactNode;
}

interface SettingsContextData {
  messageTitle: string;
  updateMessageTitle: (newTitle: string, emailBody?: string) => void;
  setMessageTitle: Dispatch<SetStateAction<string>>;
  getMessageTitleByUserId: (UserId: string) => any;
  messageEmailBody: string;
  setMessageEmailBody: Dispatch<SetStateAction<string>>;
}

const initialState: SettingsContextData = {
  messageTitle: "",
  updateMessageTitle: () => {},
  setMessageTitle: () => {},
  getMessageTitleByUserId: () => {},
  messageEmailBody: "",
  setMessageEmailBody: () => {},
};

export const SettingsContext = createContext<SettingsContextData>(initialState);

export default function SettingsContextProvider({
  children,
}: SettingsContextProviderProps) {
  const {
    messageTitle,
    updateMessageTitle,
    setMessageTitle,
    getMessageTitleByUserId,
    messageEmailBody, 
    setMessageEmailBody
  } = useSettings();

  return (
    <SettingsContext.Provider
      value={{
        messageTitle,
        updateMessageTitle,
        setMessageTitle,
        getMessageTitleByUserId,
        messageEmailBody, 
    setMessageEmailBody
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}
